import ContactUs from "../component/ContactUs";
import Footer from "../component/Footer";
import Navbar from "../component/navbar/Navbar";

export default function ContactUsPage(){

    return (
        <>
            <Navbar/>
            <ContactUs/>
            <Footer/>
        </>
    )
}